import { ADSApiError } from '@ads/front-core/interfaces'

export const logError = (e?: Error | ADSApiError): void => {
  console.error('ADS Error', e)
}
